import { User } from 'types/user';
import UserInfoSection from 'ui-component/UserInfoSection';

export function RenderUserNameCell(
  value?: Pick<
    User,
    'firstName' | 'lastName' | 'title' | 'email' | 'isStaff' | 'image'
  >,
  subtitle?: string,
  automation?: boolean
) {
  return (
    <UserInfoSection user={value} subtitle={subtitle} automation={automation} />
  );
}
